var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBranch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 8",
  cx: 2,
  cy: 3,
  r: 1.5,
  fill: "none",
  stroke: "currentColor"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 10",
  cx: 8,
  cy: 3,
  r: 1.5,
  fill: "none",
  stroke: "currentColor"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 9",
  cx: 2,
  cy: 11,
  r: 1.5,
  fill: "none",
  stroke: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Union",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 4H2.5V7.26389C3.03076 6.78885 3.73165 6.5 4.5 6.5H6.5C7.05228 6.5 7.5 6.05228 7.5 5.5V4H8.5V5.5C8.5 6.60457 7.60457 7.5 6.5 7.5L5.5 7.5H4.5C3.39543 7.5 2.5 8.39543 2.5 9.5V10H1.5V9.5V4Z",
  fill: "currentColor"
})));
export default SvgBranch;